import { useFormikContext } from "formik";
import get from "lodash-es/get";
import React from "react";
import PropTypes from "prop-types";
import MuiBox from "@mui/material/Box";
import Switch from "ui/Switch";
import Typography from "ui/Typography";

export const FormSwitchField = (props) => {
  const { name, label, padding = "7px 0", ...otherProps } = props;
  const formik = useFormikContext();

  const value = get(formik.values, name, false);

  const handleChange = async (event) => {
    await formik.setFieldValue(name, event.target.checked);
  };

  const style = {
    padding,
    display: "flex",
    gap: "16px",
    alignItems: "center",
  };

  return (
    <MuiBox sx={style}>
      <Typography variant="subtitle1" flex="1 0 0">
        {label}
      </Typography>
      <Switch
        name={name}
        checked={value}
        label={label}
        onChange={handleChange}
        {...otherProps}
      />
    </MuiBox>
  );
};
FormSwitchField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  padding: PropTypes.string,
};
